import { useNavigate, useParams, useSearchParams } from 'react-router-dom';

import { HMJobEditForm } from '@/modules/hiring-manager/components/jobEditor/HMJobEditForm';
import { toSearchSuffix } from '@/modules/hiring-manager/utils/searchSuffix';

/** The customer's edit route: the job's editor, back to the jobs page once it's saved. */
export function HMJobEdit() {
  const navigate = useNavigate();
  const { jobId } = useParams<{ jobId: string }>();
  const [searchParams] = useSearchParams();

  return (
    <HMJobEditForm
      jobId={jobId!}
      onSaved={() => navigate(`/hm${toSearchSuffix(searchParams)}`)}
    />
  );
}
